'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const TableColumn=require('../../../../dist-es6/client/directives/sortableTableDirective/tableColumn');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const DefaultDebounceRate=150;
const AvailableMatchTypes=['and','or'];
const DefaultMatchType=AvailableMatchTypes[1];let

SearchDirective=function(_BaseControllerBacked){_inherits(SearchDirective,_BaseControllerBacked);function SearchDirective(){_classCallCheck(this,SearchDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(SearchDirective,[{key:'objectBindings',get:function()
{
return['data','searchableProperties','filteredData','currentFilter','lastUpdateTime','debounceRate','orSeparator','onMatchTransform','searchInputFocused','summary'];
}},{key:'textBindings',get:function()

{
return['placeholderText','matchType'];
}},{key:'templateUrl',get:function()

{
return'/templates/directives/searchDirective/searchTemplate';
}},{key:'controller',get:function()

{
return SearchDirectiveController;
}}]);return SearchDirective}(BaseControllerBackedDirective);let


SearchDirectiveController=function(){_createClass(SearchDirectiveController,null,[{key:'$inject',get:function()
{
return['$scope','$timeout'];
}}]);

function SearchDirectiveController($scope,$timeout){var _this2=this;_classCallCheck(this,SearchDirectiveController);
this._$timeout=$timeout;
this.debounceRate=this.debounceRate||DefaultDebounceRate;

if(!_.exists(this.currentFilter)){
this._currentFilter='';
}

this.searchableProperties=this.searchableProperties||_.keys(this.data[0]);
this.matchType=this.matchType||DefaultMatchType;
this.searchInputFocused=!1;

if(!AvailableMatchTypes.includes(this.matchType)){
throw new Error(`[SearchDirective]: matchType "${this.matchType}" is not supported, must be one of available match types: ${AvailableMatchTypes}`);
}

this.orSeparatorRegex=_.exists(this.orSeparator)?
this.orSeparator instanceof RegExp?
this.orSeparator:
new RegExp(`\s+${this.orSeparator}\s+`,'gi'):
/\s+or\s+/gi;

this._performUpdate="production"==='test'?
function(){return _this2._updateFilteredData()}:
_.debounce(function(){return _this2._updateFilteredData()},this.debounceRate);

$scope.$watchGroup([
'controller.data',
'controller.searchableProperties',
'controller.currentFilter'],
function(){return _this2._performUpdate()});

this.currentPlaceholderText=this.placeholderText=this.placeholderText||'Search';
}SearchDirectiveController.prototype.

_updateSearchData=function _updateSearchData(){
const len=this.data.length;
const searchData=Array(len);
for(let i=0;i<len;i++){
searchData[i]=_.at(this.data[i],this.searchableProperties).join('!');
}

this._sourceDataForSearch=this.data;
this._sourcePropertiesForSearch=this.searchableProperties;
this._searchData=searchData;
};SearchDirectiveController.prototype.

_setData=function _setData(data){var _this3=this;
if(_.exists(data)&&_.isEqual(this._filteredData,data)){
return;
}


const summary=this.data?{found:data.length,total:this.data.length}:void 0;

this._$timeout(function(){
_this3._summary=summary;
_this3._filteredData=data;
_this3._attachMethodsForMaterialOnDemand(_this3._filteredData);
_this3.lastUpdateTime=Date.now();
});
};SearchDirectiveController.prototype.

_attachMethodsForMaterialOnDemand=function _attachMethodsForMaterialOnDemand(arr){
if(!arr){
return;
}

arr.getItemAtIndex=function(index){return arr[index]};
const len=arr.length;
arr.getLength=function(){return len};
};SearchDirectiveController.prototype.

_updateFilteredData=function _updateFilteredData(){var _this4=this;
const currentFilter=_.toString(this._currentFilter).trim();
if(!currentFilter){
this._setData(this.data);
return;
}

if(this._sourceDataForSearch!==this.data||this._sourcePropertiesForSearch!==this.searchableProperties){
if(!this.data){
return;
}
this._updateSearchData();
}

const words=_.uniq(currentFilter.split(/\s+/g).map(function(s){return s.trim()}).filter(function(s){return!!s}));
const andMatcherRegex=new RegExp(words.map(function(word,i){return`(?=.*\\b${_escapeRegExpCharactersAndOrSeparator(word,_this4.orSeparatorRegex)})`}).join(''),'i');

const filterRegExp=new RegExp(_escapeRegExpCharactersAndOrSeparator(currentFilter,this.orSeparatorRegex),'i');
const lowerCaseFilter=currentFilter.toLowerCase();

const len=this._searchData.length;
const filteredData=Array(len);

const _isMatch=this.matchType==='or'?
function(i){return _this4._searchData[i].toLowerCase().indexOf(lowerCaseFilter)!==-1||filterRegExp.test(_this4._searchData[i])}:
function(i){return andMatcherRegex.test(_this4._searchData[i])};

const _addMatchResult=this.onMatchTransform?
function(i){return filteredData[i]=_this4.onMatchTransform(_this4._sourceDataForSearch[i],words,_this4._searchData[i].match(filterRegExp))}:
function(i){return filteredData[i]=_this4._sourceDataForSearch[i]};

for(let i=0;i<len;i++){
if(_isMatch(i)){
_addMatchResult(i);
}
}

this._setData(_.compact(filteredData));
};_createClass(SearchDirectiveController,[{key:'currentFilter',get:function()

{
return this._currentFilter;
},set:function(

currentFilter){
if(this._currentFilter===currentFilter){
return;
}

this._currentFilter=currentFilter;
}},{key:'filteredData',set:function(

value){

},get:function()

{
return this._filteredData;
}},{key:'tableColumns',get:function()

{
return this._tableColumns;
}},{key:'summary',get:function()

{
return this._summary;
},set:function(

nope){

}}]);return SearchDirectiveController}();


function _escapeRegExpCharactersAndOrSeparator(value,orSeparatorRegex){
return _.escapeRegExp(value).replace(orSeparatorRegex,'|');
}

module.exports=SearchDirective;
module.exports.controller=SearchDirectiveController;
//# sourceMappingURL=searchDirective.js.map
